/**
 * Zentrierte Fenster-Position im Viewport (Mail→Vorgang SP3, C1: das
 * Light-Erstell-Popup „poppt immer zentriert auf"). Pure Funktion — der
 * Viewport kommt als Parameter (vitest-testbar ohne DOM).
 * Bei Fenstern größer als der Viewport wird oben/links auf einen kleinen
 * Rand geklemmt, damit die Titelleiste greifbar bleibt.
 */
export function centeredPosition(
    size: { width: number; height: number },
    viewport: { width: number; height: number },
): { x: number; y: number } {
    const margin = 12;
    return {
        x: Math.max(margin, Math.round((viewport.width - size.width) / 2)),
        y: Math.max(margin, Math.round((viewport.height - size.height) / 2)),
    };
}

/**
 * Fenstergröße an die verfügbare Fläche (den Fenster-Layer) anpassen (T-27):
 * Ein Fenster, das größer ist als der Layer, wird auf Layer minus Rand
 * verkleinert — sonst liegt seine Fußzeile auf einem Laptop (1282×728) dauerhaft
 * unter dem sichtbaren Bereich und ist nicht erreichbar. Passt das Fenster,
 * bleibt die Größe exakt; die Mindestmaße des Fensters werden nie unterschritten.
 */
export function fitToViewport(
    size: { width: number; height: number },
    viewport: { width: number; height: number },
    min: { width: number; height: number } = { width: 420, height: 320 },
    margin = 12,
): { width: number; height: number } {
    return {
        width: Math.max(min.width, Math.min(size.width, viewport.width - 2 * margin)),
        height: Math.max(min.height, Math.min(size.height, viewport.height - 2 * margin)),
    };
}
